let today = new Date();
let firstDay1 = new Date(today.getFullYear(), today.getMonth(), 1).getDay();
let month1 = new Date(today.getFullYear(), today.getMonth(), 1).getMonth();
let year1 = new Date(today.getFullYear(), today.getMonth(), 1).getFullYear();

let firstDay2 = new Date(today.getFullYear(), today.getMonth()+1, 1).getDay();
let month2 = new Date(today.getFullYear(), today.getMonth()+1, 1).getMonth();
let year2 = new Date(today.getFullYear(), today.getMonth()+1, 1).getFullYear();

window.addEventListener('load', function () {
  loadCalendar();
});


function loadCalendar() {
  let holidaysArr = window.holidays.split(";");
  // console.log(holidaysArr);
  
  let caption1 = year1+'年'+(month1+1)+'月';
  let caption2 = year2+'年'+(month2+1)+'月';
  document.getElementById("caption1").innerHTML = caption1;
  document.getElementById("caption2").innerHTML = caption2;

  let tbl1 = document.getElementById("calendar1-body");
  let tbl2 = document.getElementById("calendar2-body");
  tbl1.innerHTML = "";
  tbl2.innerHTML = "";
  
  // Transform Table1
  var date1 = 1;
  for (var i = 0; i < 6; i++) {
    // creates a table row
    var row = document.createElement("tr");
    row.classList.add("ygb-font-family-NotoSans");
    row.classList.add("ygb-calendar-days");

    //creating individual cells, filing them up with data.
    for (var j = 0; j < 7; j++) {
      if (i === 0 && j < firstDay1) {
        cell = document.createElement("th");
        cellText = document.createTextNode(" ");
        cell.appendChild(cellText);
        row.appendChild(cell);
      } else if (date1 > daysInMonth(month1, year1)) {
        // Out of date
        break;
      } else {
        cell = document.createElement("th");
        
        var fdate1 = ''+date1;
        var fmon1 = ''+(month1+1);
        var formatDate1 = year1+'-'+fmon1.padStart(2, '0')+'-'+fdate1.padStart(2, '0');
   
        if (holidaysArr.includes(formatDate1)) {
          cell.classList.add("holy-day");
        }
        cellText = document.createTextNode(date1);
        cell.appendChild(cellText);
        row.appendChild(cell);
        
        date1++;
      }
    }

    tbl1.appendChild(row);
  }
  
  // Transform Table2
  var date2 = 1;
  for (var i = 0; i < 6; i++) {
    // creates a table row
    var row = document.createElement("tr");
    row.classList.add("ygb-font-family-NotoSans");
    row.classList.add("ygb-calendar-days");
    //creating individual cells, filing them up with data.
    for (var j = 0; j < 7; j++) {
      if (i === 0 && j < firstDay2) {
        cell = document.createElement("th");
        cellText = document.createTextNode("");
        cell.appendChild(cellText);
        row.appendChild(cell);
      } else if (date2 > daysInMonth(month2, year2)) {
        // Out of date
        break;
      } else {
        cell = document.createElement("th");
        var fdate2 = ''+date2;
        var fmon2 = ''+(month2+1);
        var formatDate2 = year2+'-'+fmon2.padStart(2, '0')+'-'+fdate2.padStart(2, '0');
      
        if (holidaysArr.includes(formatDate2)) {
          cell.classList.add("holy-day");
        }
        cellText = document.createTextNode(date2);
        cell.appendChild(cellText);
        row.appendChild(cell);
        
        date2++;
      }
    }

    tbl2.appendChild(row);
  }
  
  // document.getElementById("show-calendar-toggle").style.display = "block";
}

function toggleCalendar() {
  
  // if(document.getElementById("toggle-calendar-block").style.display == 'none'){
  //   document.getElementById("toggle-calendar-block").style.display = "block";
  // } else {
  //   document.getElementById("toggle-calendar-block").style.display = "none";
  // }
}

function daysInMonth(iMonth, iYear) {
    return 32 - new Date(iYear, iMonth, 32).getDate();
}
